export enum THEME_TYPES {
  DEFAULT = 'DEFAULT',
  BG_BLACK__CLR_WHITE__CTABG_WHITE__CTACLR_BLACK = 'BG_BLACK__CLR_WHITE__CTABG_WHITE__CTACLR_BLACK',
}
